// @flow

import styled from 'styled-components';
import { Label } from './label';

export const VerticalLabel = styled(Label)`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  padding: 16px 0;
  width: 100%;
`;
